module.exports = __webpack_public_path__ + "officialStatic/img/case1.6a21bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/case1.png
// module id = fcjf
// module chunks = 0